import axiosInstance from "./config";
import { IDynamicFeesCreate } from "views/admin/dynamicFees/types/fees.interface";

const basePath = `/induk-app/dynamic-fees`;

export const getFees = () => {
  return axiosInstance.get(`${basePath}`);
};

export const addFee = (payload: IDynamicFeesCreate) => {
  return axiosInstance.post(`${basePath}/create`, payload);
};

export const getFee = (id: string) => {
  return axiosInstance.get(`${basePath}/${id}`);
};

export const updateFee = (id: number, payload: Partial<IDynamicFeesCreate>) => {
  return axiosInstance.patch(`${basePath}/${id}/update`, payload);
};

export const deleteFee = (id: number) => {
  return axiosInstance.delete(`${basePath}/${id}/delete`);
};
